import { UserGender } from "@/generated-api";
import { Button } from "@/components/ui/button";
import chessKingLight from "@/assets/chess-king-light.svg";
import chessKingDark from "@/assets/chess-king-dark.svg";
import chessQueenLight from "@/assets/chess-queen-light.svg";
import chessQueenDark from "@/assets/chess-queen-dark.svg";
import { useTranslation } from "@/hooks/useTranslation";

export default function GenderSelectCard({
  gender,
  setGender,
}: {
  gender: UserGender | null;
  setGender: (g: UserGender) => void;
}) {
  const t = useTranslation();

  return (
    <div className="dark w-fit mx-auto text-white space-y-6">
      <div className="text-center">{t.GENDER_SELECT_CARD.LABELS.PROMPT}</div>
      <div className="grid grid-cols-2 gap-5">
        <Button
          className="flex-col items-center py-12 px-8 rounded-xl"
          variant={gender === UserGender.MALE ? "default" : "outline"}
          onClick={() => setGender(UserGender.MALE)}
        >
          <img
            src={gender === UserGender.MALE ? chessKingDark : chessKingLight}
            alt="Chess King Figure"
            className="w-10 h-10"
          />
          {t.GENDER_SELECT_CARD.LABELS.MALE}
        </Button>
        <Button
          className="flex-col items-center py-12 px-8 rounded-xl"
          variant={gender === UserGender.FEMALE ? "default" : "outline"}
          onClick={() => setGender(UserGender.FEMALE)}
        >
          <img
            src={
              gender === UserGender.FEMALE ? chessQueenDark : chessQueenLight
            }
            alt="Chess Queen Figure"
            className="w-10 h-10"
          />
          {t.GENDER_SELECT_CARD.LABELS.FEMALE}
        </Button>
      </div>
    </div>
  );
}
